var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-typography',{attrs:{"value":((_vm.dailyOfferInfo.sales_staff_name) + " (" + (_vm.dailyOfferInfo.count) + ")"),"single":""}})}
var staticRenderFns = []

export { render, staticRenderFns }